export default "__VITE_ASSET__DZQXY$0c__"